import axios from 'axios'
import store from '@/store'

const http = axios.create({
  // baseURL: 'https://portal-api-dev.unicampo.coop.br/',
  // baseURL: 'https://portal-api-hmg.unicampo.coop.br/',
  baseURL: 'https://portal-api.unicampo.coop.br/',
  // baseURL: 'http://localhost:8000/', 

  headers: {
    'Accept': 'application/json',
    'Content': 'application/json',
  }
})


http.interceptors.request.use(function (config) {
  const token = store.state.access_token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers.modulo = store.state.rotaAtual;

  return config
}, function (erro) {
  return Promise.reject(erro)
})

export default http
